module.exports = __webpack_public_path__ + "static/media/speech_bubbles.be6e8f4b.webp";